import EmptyInterview from './EmptyInterview.component';

export default EmptyInterview;
